import axios from "../../../api/axios";

export const fetchOfficeInfo = () => (
    axios.get('/office-info').then(res=>res.data)
)